import React from 'react'
import VisibiltySensor from '../VisibilitySensor'
import Content from './Content'
import { makeStyles } from '@material-ui/core/styles'
import VideoFrame from './VideoFrame'
import { RealizzazionePageConfig } from '../../configuration'
import AssignId from '../AssignId'

export const styles = theme => ({
    root: {
        padding: '90px 270px',
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
        alignItems: 'center',
        flexDirection: 'column',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1400)]: {
            padding: '90px 10rem'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1100)]: {
            padding: '40px 5rem'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 950)]: {
            padding: '40px 1rem 60px 1rem'
        }
    },
    wrap: {
        backgroundColor: '#EFEEEB',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
            backgroundColor: '#E1DDD9'
        }
    },
    frameWrap: {
        width: '100%',
        height: '100%',
        maxWidth: '896px'
    }
})

const useStyles = makeStyles(styles)

export default function Realizzazione() {
    const classes = useStyles()
    return (
        <div className={classes.wrap} >
            <div className={classes.root} >
                <AssignId
                    absolute
                    y='-10px'
                    yMobile='-50px'
                    id={RealizzazionePageConfig.slug}
                />
                <VisibiltySensor index={2} />
                <Content
                    primaryText={RealizzazionePageConfig.content.primary}
                    secondaryText={RealizzazionePageConfig.content.secondary} />
                <div className={classes.frameWrap} >
                    <VideoFrame id={RealizzazionePageConfig.videoID} />
                </div>
            </div>
        </div>
    )
}